import { XAxis } from 'recharts';

// @ts-ignore
XAxis.defaultProps.stroke = '#a6b0b3';
// @ts-ignore
XAxis.defaultProps.tickLine = false;
// @ts-ignore
XAxis.defaultProps.tickMargin = 8;
// @ts-ignore
XAxis.defaultProps.minTickGap = 15;

export { XAxis };
